import type { FragmentOf } from '@/utilities/gql';
import { gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { NARRATIVE_CARD_ISOMORPHIC_FRAGMENT } from '@/components/NarrativeCard';
import { FAIR_VALUE_HISTOGRAM_COMPANY_FRAGMENT } from '../../FairValueHistogram/fairValueHistogramFragment';

const COMPANY_REPORT_NARRATIVE_CARD_FRAGMENT = gql(
  `
  fragment CompanyReportNarrativeCardFields on Narrative @_unmask {
    id
    company {
      id
      uniqueSymbol
    }
    ...NarrativeCardIsomorphicFields
  }
`,
  [NARRATIVE_CARD_ISOMORPHIC_FRAGMENT]
);

const QUERY = gql(
  `
  query CompanyNarrativesWithHistogram($canonicalUrl: String!) {
    company: Company(canonicalURL: $canonicalUrl) {
      id
      uniqueSymbol
      name
      myNarrative {
        ...CompanyReportNarrativeCardFields
      }
      myValuation {
        narrative {
          ...CompanyReportNarrativeCardFields
        }
      }
      ...FairValueHistogramCompanyFields
    }
    narratives(first: 4, filter: { canonicalUrl: $canonicalUrl }, sort: { field: POPULARITY, direction: DESC }) {
      edges {
        node {
          ...CompanyReportNarrativeCardFields
        }
      }
    }
  }
`,
  [
    COMPANY_REPORT_NARRATIVE_CARD_FRAGMENT,
    FAIR_VALUE_HISTOGRAM_COMPANY_FRAGMENT,
  ]
);

export const useCompanyNarratives = makeGqlSuspenseQuery(QUERY, {
  tags: ['narrative', 'narrative-company-report-list'],
  staleTime: 0,
});

export type Narrative = FragmentOf<
  typeof COMPANY_REPORT_NARRATIVE_CARD_FRAGMENT
>;
